import { event } from '@zillow/universal-analytics';

const ENABLED = false;

const ENVELOPE = {
    event_template_id: '126',
    event_template_version_id: '1',
    event_type_version_id: '1',
};
const EVENT_TYPE_IDS = {
    impression: '2284',
    close: '2051',
};

export type BannerEventContext = {
    /** Banner post id. */
    bannerId: string;
    /** Whether the banner offers a close affordance. */
    dismissible: boolean;
    /** Site slug the banner rendered on, e.g. `PREFERRED`. */
    surface?: string;
    /** Id of the post/page the banner rendered on. */
    contentId?: string;
};

const buildPayload = (
    eventTypeId: string,
    semanticEventName: string,
    triggerType: string,
    context: BannerEventContext
) => ({
    envelope: { ...ENVELOPE, event_type_id: eventTypeId },
    clickstream_trigger: {
        trigger_location_nm: 'cms_banner',
        trigger_type_nm: triggerType,
        trigger_object_nm: 'cms_banner_object',
        trigger_source_nm: context.surface || 'cms_banner',
    },
    semantic: {
        topic_tag_txt: ['banner'],
        semantic_event_nm: semanticEventName,
    },
    cms_banner: {
        banner_id_txt: context.bannerId,
        // Field name is fixed by the registered Clickstream schema
        // (template 126); it carries the banner's `dismissible` setting.
        closeable_ind: context.dismissible,
        content_id_txt: context.contentId || '',
    },
});

export const trackBannerImpression = (context: BannerEventContext): void => {
    if (!ENABLED) return;
    event(
        buildPayload(EVENT_TYPE_IDS.impression, 'view_content', 'view', context)
    );
};

export const trackBannerClose = (context: BannerEventContext): void => {
    if (!ENABLED) return;
    event(
        buildPayload(
            EVENT_TYPE_IDS.close,
            'cms_banner_close',
            'interaction',
            context
        )
    );
};
